"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.join_args = void 0;
function join_args(...args) {
    const str = args
        .map(x => {
        // Avoid adding extra \" chars if we're just dealing with strings
        if (typeof x == 'string') {
            return x;
        }
        try {
            return JSON.stringify(x);
        }
        catch {
            return x.toString();
        }
    })
        .join(' ');
    return str;
}
exports.join_args = join_args;
